import { getUserDisplayName } from '@vestigas/utils';

import {
  type AvatarUser,
  UserAvatar,
  type UserAvatarSize,
} from '~/ui/atoms/UserAvatar';

type UserAvatarLabelProps = {
  readonly size?: UserAvatarSize;
  readonly user: AvatarUser;
};

/** Avatar beside the user's name, with the e-mail address underneath when a name is stored. */
export function UserAvatarLabel({ size, user }: UserAvatarLabelProps) {
  const displayName = getUserDisplayName(user);

  return (
    <span className="flex min-w-0 items-center gap-3">
      <UserAvatar size={size} user={user} />
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-medium wrap-break-word">
          {displayName}
        </span>
        {displayName === user.email ? null : (
          <span className="block text-xs wrap-break-word text-tiga-text-lighter">
            {user.email}
          </span>
        )}
      </span>
    </span>
  );
}
